module.exports = {
	"Tacos": [
		"https://media.giphy.com/media/Ecz51X5IAD5DO/giphy.gif",
		"https://media.giphy.com/media/pOD33maTjaVvq/giphy.gif",
		"https://media.giphy.com/media/8K1IYSnhUaNH2/giphy.gif",
		"https://media.giphy.com/media/QGrAoK4eEngA0/giphy.gif",
		"https://media.giphy.com/media/x5clhLXINq4c8/giphy.gif"
	],
	"Left Sharks": [
		"https://media.giphy.com/media/H0pS4k8Y3A5CE/giphy.gif",
		"https://media.giphy.com/media/3xz2BvcsZ6FXGurVS0/giphy.gif",
		"https://media.giphy.com/media/hpCNJ55ww3sJ2/giphy.gif",
		"https://media.giphy.com/media/3rgXBRcIF1BpTZMFpu/giphy.gif",
		"https://media.giphy.com/media/13jEtzYC1q5ccg/giphy.gif"
	],
	"Nae Naes": [
		"https://media.giphy.com/media/l41lPnsw4tL9W8O76/giphy.gif",
		"https://media.giphy.com/media/ITd7F7W7WM7f2/giphy.gif",
		"https://media.giphy.com/media/3o85xsLZa2mcGY7nm8/giphy.gif",
		"https://media.giphy.com/media/ThZq64lM2jQL6/giphy.gif",
		"https://media.giphy.com/media/lAaTl0aszvgLC/giphy.gif"
	],
	"Bluths": [
		"https://media.giphy.com/media/aA3jjHGsTdAsw/giphy.gif",
		"https://media.giphy.com/media/68MP3aJkj9KzC/giphy.gif",
		"https://media.giphy.com/media/LOZ7D34vE8mIw/giphy.gif",
		"https://media.giphy.com/media/S7aF5YPXDMMwM/giphy.gif",
		"https://media.giphy.com/media/JWCahAf61Z43e/giphy.gif",
		"https://media.giphy.com/media/ktZJlSaABbSOk/giphy.gif"
	],
	"Otters": [
		"https://media.giphy.com/media/12AY0A3PWhI9So/giphy.gif",
		"https://media.giphy.com/media/QcIhKTnPVZu48/giphy.gif",
		"https://media.giphy.com/media/slNwi1TTwR40U/giphy.gif",
		"https://media.giphy.com/media/3RBctIB0FOiHe/giphy.gif",
		"https://media.giphy.com/media/U1gBebqyLtb4k/giphy.gif"
	],
	"Dinosaurs": [
		"https://media.giphy.com/media/7tUFxA4PSWwOQ/giphy.gif",
		"https://media.giphy.com/media/3rgXBvnbXtxwaWmhr2/giphy.gif",
		"https://media.giphy.com/media/3o85xlDHNGjSuBkbkc/giphy.gif",
		"https://media.giphy.com/media/9Yl2liu9cEzzq/giphy.gif",
		"https://media.giphy.com/media/10D4oCT4zUAvRK/giphy.gif"
	],
	"Laser Cats": [
		"https://media.giphy.com/media/WSYFrDXNpZZKw/giphy.gif",
		"https://media.giphy.com/media/3o85xoi6nNqJQJ95Qc/giphy.gif",
		"https://media.giphy.com/media/e3NinswgSNdRu/giphy.gif",
		"https://media.giphy.com/media/A4QpBHe8ZlmLu/giphy.gif",
		"https://media.giphy.com/media/3oEduQAsYcJKQH2XsI/giphy.gif"
	],
	"Wiggles": [
		"https://media.giphy.com/media/VcTOY2C5TmuRi/giphy.gif",
		"https://media.giphy.com/media/cPxRDvlSj9QKA/giphy.gif",
		"https://media.giphy.com/media/3hMnjzecAjQcw/giphy.gif",
		"https://media.giphy.com/media/yidUzil7u0LK8kbtvy/giphy.gif",
		"https://media.giphy.com/media/l41m73JY35qIhKK8U/giphy.gif"
	],
	"Bees": [
		"https://media.giphy.com/media/wOzqfLdooUTHW/giphy.gif",
		"https://media.giphy.com/media/YPjFIgSccMHS0/giphy.gif",
		"https://media.giphy.com/media/oPGQ9fyuxhNTy/giphy.gif",
		"https://media.giphy.com/media/dccXpadr6fhF6/giphy.gif",
		"https://media.giphy.com/media/2e7fhO2LuJ7by/giphy.gif"
	],
	"Puppies": [
		"https://media.giphy.com/media/DdotCCeucTHmU/giphy.gif",
		"https://media.giphy.com/media/z6kbOHCqOxtba/giphy.gif",
		"https://media.giphy.com/media/ToMjGpjwk1MxyYRcQnK/giphy.gif",
		"https://media.giphy.com/media/tBb19fjQsnXRgMT3kZi/giphy.gif",
		"https://media.giphy.com/media/l41lYs6dLc19noLeg/giphy.gif"
	]
};


/*****************
 ** WEBPACK FOOTER
 ** ./web/static/config/team_gifs.json
 ** module id = 188
 ** module chunks = 0
 **/